import { ArrowUp, ArrowDown, Minus } from "lucide-react";

/**
 * TrendBadge — compact trend indicator.
 *
 * Props:
 *   trend: { delta_pct: number, direction: "up"|"down", period: string, is_improving: boolean }
 *   size:  "sm" | "md"
 */
export default function TrendBadge({ trend, size = "md", testid }) {
  if (!trend) return null;
  const { delta_pct, direction, period, is_improving } = trend;
  const Icon = delta_pct === 0 ? Minus : direction === "up" ? ArrowUp : ArrowDown;
  const tone = delta_pct === 0
    ? { bg: "rgba(74,90,106,0.10)", fg: "var(--cv-slate)" }
    : is_improving
    ? { bg: "rgba(62,124,79,0.13)", fg: "var(--cv-green)" }
    : { bg: "rgba(165,48,15,0.13)", fg: "var(--cv-crimson)" };
  const pad = size === "sm" ? "px-1.5 py-[1px] text-[11px]" : "px-2 py-[2px] text-[12px]";
  const sign = delta_pct > 0 ? "+" : "";
  return (
    <span
      data-testid={testid || "trend-badge"}
      data-direction={direction}
      data-improving={String(is_improving)}
      className={`inline-flex items-center gap-1 rounded-full font-bold ${pad}`}
      style={{ background: tone.bg, color: tone.fg }}
    >
      <Icon className={size === "sm" ? "w-3 h-3" : "w-3.5 h-3.5"} strokeWidth={2.6} />
      <span className="tabular-nums">{sign}{delta_pct}%</span>
      <span className="opacity-70 font-normal">{period}</span>
    </span>
  );
}
